import { InjectionToken } from '@angular/core';

/**
 * Injection token for the API base URL.
 * Provide this token in the app config to set the API URL.
 */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
